define(["exports", "react", "react-intl-universal", "styled-components", "../../atoms/", "../../molecules/"], function (_exports, _react, _reactIntlUniversal, _styledComponents, _atoms, _molecules) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _reactIntlUniversal = _interopRequireDefault(_reactIntlUniversal);
  _styledComponents = _interopRequireDefault(_styledComponents);

  var ItemLanguage = _styledComponents.default.div.withConfig({
    displayName: "Language__ItemLanguage",
    componentId: "sc-1n2o0qf-0"
  })(["h2{margin:0 0 16px;}p{font-size:1.4em;margin:0;@media print{text-align:left;}}"]);

  var Language = function Language(_ref) {
    var languages = _ref.languages;

    var _intl$getInitOptions = _reactIntlUniversal.default.getInitOptions(),
        locales = _intl$getInitOptions.locales,
        _intl$getInitOptions$ = _intl$getInitOptions.currentLocale,
        currentLocale = _intl$getInitOptions$ === void 0 ? 'pt_BR' : _intl$getInitOptions$;

    return /*#__PURE__*/_react.default.createElement(ItemLanguage, null, /*#__PURE__*/_react.default.createElement(_atoms.H2, null, _reactIntlUniversal.default.get('IDIOMA.TITULO')), /*#__PURE__*/_react.default.createElement(_molecules.Languages, {
      languages: languages,
      i18n: locales[currentLocale],
      currentLocale: currentLocale
    }));
  };

  Language.defaultProps = {
    languages: []
  };
  var _default = Language;
  _exports.default = _default;
});